import { useDictado } from "../voz.ts";

/** Campo de una línea que se llena a mano o dictando (botón del micrófono): lo dictado se agrega al final. */
export function CampoDictable({ valor, alCambiar, etiqueta, placeholder, max = 120 }: { valor: string; alCambiar: (v: string) => void; etiqueta: string; placeholder?: string; max?: number }) {
  const voz = useDictado((t) => alCambiar(`${valor ? `${valor.trimEnd()} ` : ""}${t}`.slice(0, max)));
  return (
    <span className="fila" style={{ gap: 4, flexWrap: "nowrap" }}>
      <input value={valor} maxLength={max} placeholder={placeholder} aria-label={etiqueta} style={{ flex: 1, minWidth: 0 }} onChange={(e) => alCambiar(e.target.value)} />
      {voz.soportado && (
        <button type="button" className={`btn chico mic${voz.escuchando ? " on" : ""}`} onClick={voz.escuchando ? voz.detener : voz.iniciar} aria-pressed={voz.escuchando}
          aria-label={voz.escuchando ? `Detener el dictado de ${etiqueta.toLowerCase()}` : `Dictar ${etiqueta.toLowerCase()}`} title={voz.escuchando ? "Detener" : "Dictar"}>{voz.escuchando ? "■" : "🎤"}</button>
      )}
      {voz.provisional && <small className="muted" aria-live="polite">{voz.provisional}</small>}
    </span>
  );
}
